import type { ProductList, ProductPlan, TeamProductList, TeamProductPlan } from '@/app/types';

const DEFAULT_PLAN: ProductPlan = {
  free: null,
  standard_v2: null,
  premium_v2: null,
  ultimate_v2: null,
};

export const PRODUCTS_LIST_DEFAULT_DATA: ProductList = {
  subscription_monthly: { ...DEFAULT_PLAN },
  subscription_quarterly: { ...DEFAULT_PLAN },
  subscription_yearly: { ...DEFAULT_PLAN },
  pass_monthly: { ...DEFAULT_PLAN },
  pass_quarterly: { ...DEFAULT_PLAN },
  pass_yearly: { ...DEFAULT_PLAN },
};

const DEFAULT_TEAM_PLAN: TeamProductPlan = {
  basic: null,
  plus: null,
  pro: null,
};

export const TEAM_PRODUCTS_LIST_DEFAULT_DATA: TeamProductList = {
  team_yearly: { ...DEFAULT_TEAM_PLAN },
  team_quarterly: { ...DEFAULT_TEAM_PLAN },
};
